import React, { useState, useEffect } from 'react';

import { config } from '../../config/index';

import { GET, newFetch } from '../../helpers/fetch';

import placeholderImage from '../../assets/images/placeholder.jpg';

const { SERVER_URL } = config;

const AssociateSidebar = ({
  associate,
  activeSidebar,
  setActiveSidebar,
  children,
}) => {
  return (
    <div className="right-sidebar-menu pb-4" style={{ overflowY: 'auto' }}>
      <div className="x-button-container">
        <button
          className="x-button"
          onClick={() => setActiveSidebar(!activeSidebar)}
        >
          <img
            src="https://server-mae.manpower.com.sg/public/img/6b5786439c.png"
            alt="x-icon"
          />
        </button>
      </div>
      <div className="sidebar-content">
        {/* User Img Holder */}
        <div className="sidebar-user-holder">
          <div>
            <img
              className="img-responsive rounded-circle border"
              src={
                associate.image
                  ? `${SERVER_URL}/${associate.image}`
                  : placeholderImage
              }
              alt="user-sidebar-img"
            />
            <div className="indicator" />
          </div>
          <div>
            <span>
              {associate.first_name} {associate.last_name}
            </span>
            <span>(#{associate.employee_no})</span>
          </div>
        </div>
        {/* User email and phone no */}
        <div className="d-flex justify-content-between my-4">
          <strong>Email:</strong>
          <span className="text-muted">{associate.email}</span>
        </div>

        <div className="border-separator mb-4" />

        {children}
      </div>
    </div>
  );
};

export default AssociateSidebar;
